module.exports = __webpack_public_path__ + "static/media/banner_record_bg.c8ef6f0d.png";